import { TFunction } from "i18next";

import { SelectOption } from "features/ui/Select";

export const TOP_CONTRIBUTORS_GROUP_BY_ACCESSOR = "groupByAttributeValue";
export const CLAIM_DEALER_ACCESSOR = "dealer";
export const VEHICLE_ACCESSOR = "vehicle";
export const PHOTOS_ACCESSOR = "photos";
export const VEHICLE_LAST_KNOWN_DEALER_ACCESSOR = "lastKnownDealer";

// m2m relations always have this (ECUs, Options)
export const getManyToManyPresentSelectOption = (
  t: TFunction
): SelectOption => ({
  id: "present",
  value: t("common:present"),
  label: t("common:present"),
});

export const VALUES_ENDPOINT_LIMIT_DEFAULT = 1000;
